import type { CellContext } from '@tanstack/react-table';
import type { DataGridColumnDef } from '../data-grid.type';

export function getColumnDefActions<T>(col: DataGridColumnDef<T>) {
	if (col.type !== 'actions' || !col.actions) {
		throw new Error('Column must be of type "actions" and have actions defined');
	}

	return function ActionsCell({ row }: CellContext<T, unknown>) {
		return (
			<div data-aid="data-grid-action-cell" className="flex items-center gap-2">
				{col.actions.map((action, index) => {
					const label = typeof action.label === 'function' ? action.label(row.original) : action.label;

					return (
						<button key={index} onClick={() => action.onClick(row.original)} className="p-1 hover:bg-gray-100 rounded-sm">
							{action.icon && <action.icon />}
							<span className="sr-only">{label}</span>
						</button>
					);
				})}
			</div>
		);
	};
}
